<template>
    <v-dialog
        :value="isOpen"
        max-width="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Historia zmian
                </h1>
            </v-card-title>

            <v-card-text>
                <v-data-table
                    :headers="editHistoryHeaders"
                    :items="history"
                    :items-per-page="5"
                    :page.sync="currentPaginationPage"
                    :footer-props="{
                        itemsPerPageText: 'Zmian na stronie',
                        showFirstLastPage: false
                    }"
                    :mobile-breakpoint="0"
                >
                    <template #item.createdBy="{item}">
                        <template v-if="item.createdBy.firstName && item.createdBy.lastName">
                            {{ item.createdBy.firstName }} {{ item.createdBy.lastName }}
                        </template>
                        <template v-else>
                            {{ item.createdBy.username }}
                        </template>
                    </template>
                    <template #item.createdAt="{item}">
                        {{ formatDate(item.createdAt) }}
                    </template>
                </v-data-table>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'ShippingEditHistoryDialog',
    mixins: [ dateFormatter ],
    props: {
        isOpen: {
            type: Boolean
        },
        history: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentPaginationPage: 1,
            editHistoryHeaders: [
                {
                    text: 'Użytkownik',
                    sortable: false,
                    value: 'createdBy'
                },
                {
                    text: 'Data i godzina',
                    align: 'center',
                    sortable: false,
                    value: 'createdAt'
                },
            ]
        }
    },
    methods: {
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.currentPaginationPage = 1
            }, 200)
        },
    }
}
</script>
